module.exports = __webpack_public_path__ + "static/media/linkedin-logo.35e7749b.svg";